export default "__VITE_ASSET__D6ka_cpp__"